module.exports = __webpack_public_path__ + "static/media/step-indicator-1.eb98f35d.svg";